/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { SigningFeatureConfig } from './type';

export const signing: Partial<SigningFeatureConfig> = {
    maxCaseMobileOfflineLength: 8,
    otpLengths: [4, 6, 10],
};
